module.exports = __webpack_public_path__ + "media/fallback/landscape_default-4c72a63f.png";